import { useAppNavigation } from "@/features/Navigation/hooks/useAppNavigation";
import { accept_invite_event } from "@/services/posthog/events";
import { useAnalytics } from "@/services/posthog/hooks";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate, useSearchParams } from "react-router-dom";
import { acceptInvite } from "../actions/acceptInvite";

const InviteClaim = () => {
  const { navigateToHome } = useAppNavigation();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const inviteId = searchParams.get("id");
  const analytics = useAnalytics();

  if (!inviteId) {
    return <Navigate to="/" />;
  }

  return (
    <Flex gap="4">
      <Text>You have been invited to a team</Text>
      <Button
        isLoading={loading}
        size="sm"
        onClick={async () => {
          setLoading(true);
          await acceptInvite(inviteId);
          analytics.capture(accept_invite_event);
          setLoading(false);
          navigateToHome();
        }}
      >
        Accept
      </Button>
    </Flex>
  );
};

export const InviteClaimPage = () => {
  const { navigateToHome } = useAppNavigation();
  return (
    <Flex direction="column" gap="4" padding="4">
      <Helmet>
        <title>Team Invite - Prompt Studio</title>
      </Helmet>
      <InviteClaim />
      <Box>
        <Button
          size="sm"
          onClick={() => {
            navigateToHome();
          }}
        >
          Go back
        </Button>
      </Box>
    </Flex>
  );
};
